import { Component, OnInit, OnDestroy, Renderer2 } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiService } from "../../services/api.service";
import { SharedService } from "../../services/shared.service";
interface PmsForm {
  name: string;
}

interface PmsFormCategory {
  category: string;
  forms: PmsForm[];
}

interface PmsCertificate {
  icon: string;
  name: string;
  file: string;
  desc: string;
}

@Component({
  selector: "app-pms",
  templateUrl: "./pms.component.html",
  styleUrls: ["./pms.component.scss"]
})
export class PmsComponent implements OnInit, OnDestroy {
  public NAVBAR_H = 10; // 68;
  public getInTouchShow = false;
  public regForm;
  public isSubmitted = false;
  public isError = false;

  public sectionIds = [
    "what-we-do",
    "our-benefits",
    "investment-approaches",
    "team",
    "investment-philosophy",
    "contact-details",
    "pms-forms",
    "pms-certificates"
  ];

  // ---- PMS Forms (legacy flat — kept for backwards compat) ----
  public pmsForms: PmsForm[] = [];

  // ---- PMS Forms — categorised with Download UI ----
  public pmsFormCategories: PmsFormCategory[] = [
    {
      category: "Required Document List",
      forms: [
        { name: "Required Document List - Individuals" },
        { name: "Required Document List - Individuals (Online)" },
        { name: "Required Document List - Company" },
        { name: "Required Document List - Partnership" },
        { name: "Required Document List - HUF" }
      ]
    },
    {
      category: "Account Opening Form",
      forms: [
        { name: "Account Opening Form - Individual" },
        { name: "Account Opening Form - HUF" },
        { name: "Account Opening Form - Non-individual" }
      ]
    },
    {
      category: "Additional Investment Form",
      forms: [{ name: "Additional Investment Form" }]
    },
    {
      category: "Change in Investment Approach Form",
      forms: [{ name: "Change in Investment Approach Form" }]
    },
    {
      category: "Partial Transfer Form",
      forms: [{ name: "Partial Transfer Form" }]
    },
    {
      category: "Modification Form",
      forms: [
        { name: "Modification Form" },
        { name: "Nominee Modification Form" }
      ]
    },
    {
      category: "Account Closure Forms",
      forms: [{ name: "Withdrawal Form" }]
    }
  ];

  // ---- Certificates ----
  public certificates: PmsCertificate[] = [
    {
      icon: "assets/images/icons/pdf-icon.png",
      name: "Disclosure Document",
      file: "Upachaya PMS Disclosure Document.pdf",
      desc:
        "SEBI mandated disclosure document containing all material information about our PMS strategies and fees."
    },
    {
      icon: "assets/images/icons/certificate-icon.png",
      name: "PMS Registration Certificate",
      file: "Upachaya PMS E-Certificate.pdf",
      desc:
        "SEBI Certificate of Registration — INP000009986, validating our authority to operate as a Portfolio Manager."
    },
    {
      icon: "assets/images/icons/certificate-icon.png",
      name: "Upachaya PMS Investor Charter",
      file: "Upachaya PMS Investor Charter.pdf",
      desc: "Upachaya PMS Investor Charter."
    },
    {
      icon: "assets/images/icons/certificate-icon.png",
      name: "Complaint Data PMS",
      file: "Complaint Data_PMS.pdf",
      desc: "Complaint Data PMS."
    }
  ];

  private scrollListener: () => void;
  private modalClickListener: () => void;

  constructor(
    private _api: ApiService,
    private renderer: Renderer2,
    private _shared: SharedService,
    private apiService: ApiService
  ) {}

  ngOnInit() {
    this.updateActiveTab();
    this.createForm();
    // Scroll listener
    this.scrollListener = this.renderer.listen("window", "scroll", () => {
      const navbar = document.getElementById("navbar");

      if (navbar) {
        if (window.scrollY > 60) {
          navbar.classList.add("scrolled");
        } else {
          navbar.classList.remove("scrolled");
        }
      }
      this.updateActiveTab();
    });

    // Modal outside click listener
    /* const modal = document.getElementById("modal");

    if (modal) {
      this.modalClickListener = this.renderer.listen(
        modal,
        "click",
        (e: any) => {
          if (e.target === modal) {
            this.closeModal();
          }
        }
      );
    } */
  }

  private createForm() {
    this.regForm = new FormGroup({
      // tslint:disable-next-line
      //Email , patternValidator(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      first_name: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(30),
          this._shared.CheckIfOnlyAlphabets()
        ])
      ),
      last_name: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(30),
          this._shared.CheckIfOnlyAlphabets()
        ])
      ),
      email: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.email])
      ),
      phone: new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[6-9][0-9]{9}$")
        ])
      ),
      address: new FormControl("", Validators.compose([Validators.required]))
      /* password: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.minLength(6)])
      ),
      confirmpassword: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.minLength(6)])
      ), 
      termConditionIsChecked: new FormControl(false, Validators.requiredTrue)
      */
    });
  }

  ngOnDestroy() {
    if (this.scrollListener) {
      this.scrollListener();
    }

    if (this.modalClickListener) {
      this.modalClickListener();
    }
  }

  // ---- NAVBAR + TABS SCROLL BEHAVIOUR ----

  getTotalOffset(): number {
    const tabs = document.getElementById("tabsBar");
    return this.NAVBAR_H + (tabs ? tabs.offsetHeight : 50);
  }

  updateActiveTab(): void {
    const offset = this.getTotalOffset() + 20;
    const btns = document.querySelectorAll(".tab-btn");

    let current = 0;

    this.sectionIds.forEach((id, index) => {
      const el = document.getElementById(id);

      if (el && el.getBoundingClientRect().top <= offset) {
        current = index;
      }
    });

    btns.forEach((btn: Element) => {
      btn.classList.remove("active");
    });

    if (btns[current]) {
      btns[current].classList.add("active");
    }
  }

  goTo(id: string, btn?: HTMLElement): void {
    const el = document.getElementById(id);

    if (!el) {
      return;
    }

    const offset = this.getTotalOffset() + 8;

    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: top,
      behavior: "smooth"
    });

    if (btn) {
      document.querySelectorAll(".tab-btn").forEach((b: Element) => {
        b.classList.remove("active");
      });

      btn.classList.add("active");
    }
  }

  // ---- MODAL ----

  openModal(): void {
    //this.getInTouchShow = true;
  }

  closeModal(): void {
    this.getInTouchShow = false;
    /* const modal = document.getElementById("modal");

    if (modal) {
      modal.classList.remove("open");
    }

    document.body.style.overflow = ""; */
  }

  /* submitModal(): void {
    alert("Thank you! We will get in touch with you shortly.");
    this.closeModal();
  } */

  submitModal() {
    console.log("Submit ");
    this.isSubmitted = true;
    if (this.regForm.invalid) {
      return;
    }
    console.log(this.regForm.valid, this.regForm.value);
    if (this.regForm.valid) {
      const data = {
        first_name: this.regForm.value.first_name,
        last_name: this.regForm.value.last_name,
        email: this.regForm.value.email,
        mobile_number: this.regForm.value.phone,
        address: this.regForm.value.address
      };
      console.log("Form Data: ", data);
      //return;
      /* try {
        this.apiService.registerPartner(data).subscribe(
          res => {
            console.log("Register Partner ::: Res ::: ", res);
            this.isSubmitted = false;
            if (res.responseType === "success") {
              this.regEmail = res.message;
              this.regForm.reset();
              this.regSuccess = true;
            } else {
              this.regSuccess = false;
              this.regError = res.message;
            }
          },
          err => {
            console.log("Register Partner ::: err ::: ", err, err.headers);
            if (err.error) {
              this.isSubmitted = false;
              this.regSuccess = false;
              this.regError = err.error.message;
            }
          }
        );
      } catch (error) {
        console.log("Register Partner ::: error ::: ", error);
      } */
    }
  }

  // ============================================================
  // DOWNLOAD
  // ============================================================
  public downloadFile(name: string): void {
    // In production: call this._api.get<Blob>(`pms/download?file=${name}`)
    //alert(`Downloading: ${name}\n(Wire up actual PDF URL in production.)`);
    //http://localhost:5002/frontend/pms/document-download
    /* Payload:
    {
      "file_path": "Upachaya PMS Investor Charter.pdf"
    } */
    const payload = {
      file_path: name
    };
    //const response = this.apiService.downloadPdfFile(payload);
    this.apiService.downloadPdfFile(payload).subscribe(
      res => {
        //console.log("download response >>>", res);
        if (res.status) {
          //console.log("download_url", res.download_url);
          const link = document.createElement("a");
          link.href = res.download_url;
          link.target = "_blank";
          link.download = res.filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
      err => {
        if (err.error) {
          console.log(err, err.headers);
        }
      }
    );
  }

  dlf(name: string): void {
    alert(
      "Downloading: " +
        name +
        "\n(In production this links to the actual PDF document.)"
    );
  }
}
